import React from "react";
import {Button} from "react-bootstrap";
import {Plus, Dash} from "react-bootstrap-icons";
import "../styles/ServiceCounter.css";

interface IServiceCounter {
  setVal: React.Dispatch<React.SetStateAction<number>>, 
  val: number,
}

export const ServiceCounter = ({ val, setVal }: IServiceCounter) => { 
  return (
    <div className="sc_main_con">
      <Button className="sc_btn_minus" variant="default" onClick={() => setVal(val-1)}><Dash style={{}} /></Button>
      <span className="m-auto  pl-2 pr-2 pb-0 border border-0">{val}</span>
      <Button className="sc_btn_plus" variant="default" onClick={() => setVal(val+1)}><Plus style={{}} /></Button>
  </div>
  )
};
